import { RouteRoles } from '@/router/role-routes';
import { RouteConfig, NavigationGuardNext } from 'vue-router';
import { user_store, global_store } from '@/store';
import { User } from '@/modules/user/types/index';
import { validateIntegerParam } from '@/middleware/validateIntegerParam';
import { RetroBonuses } from './types';

const check_is_global_active = (to: unknown, from: unknown, next: NavigationGuardNext) => {
  const { available_pages } = user_store.state.me;

  const active_el = available_pages?.find((el) => el.slug === RetroBonuses.Pages.RETRO_BONUSES);

  if (active_el?.is_global_active) {
    next();
  } else {
    global_store.mutations.SET_INFO_DIALOG_MODAL(true);
    next(User.Pages.PROFILE);
  }
};

const routes: RouteConfig[] = [
  {
    path: `/${RetroBonuses.Pages.RETRO_BONUSES}`,
    name: RetroBonuses.Pages.RETRO_BONUSES,
    component: () => import(/* webpackChunkName: "retro_bonuses" */ './views/RetroBonuses.vue'),
    meta: {
      access_roles: RouteRoles[RetroBonuses.Pages.RETRO_BONUSES],
    },
    beforeEnter: check_is_global_active,
  },

  {
    path: `/${RetroBonuses.Pages.RETRO_BONUSES}/:id/${RetroBonuses.Pages.RETRO_BONUSES_REWARD_DOCUMENTS}`,
    name: RetroBonuses.Pages.RETRO_BONUSES_REWARD_DOCUMENTS,
    component: () => import(/* webpackChunkName: "retro_bonuses" */ './views/RewardDocuments.vue'),
    meta: {
      access_roles: RouteRoles[RetroBonuses.Pages.RETRO_BONUSES],
    },
    beforeEnter: (to, from, next) => {
      validateIntegerParam('id')(to, from, () => {
        check_is_global_active(to, from, next);
      });
    },
  },

  {
    path: `/${RetroBonuses.Pages.RETRO_BONUSES}/${RetroBonuses.Pages.RETRO_BONUSES_REWARD_DOCUMENTS}/:id`,
    name: RetroBonuses.Pages.RETRO_BONUSES_REWARD_DOCUMENT,
    component: () => import(/* webpackChunkName: "retro_bonuses" */ './views/RewardDocumentDetail.vue'),
    meta: {
      access_roles: RouteRoles[RetroBonuses.Pages.RETRO_BONUSES],
    },
    beforeEnter: (to, from, next) => {
      validateIntegerParam('id')(to, from, () => {
        check_is_global_active(to, from, next);
      });
    },
  },
];

export default routes;
